import { RDEqipEligibilityConservationACEP } from '@cibo/core'
import { ResourceDetailFeature, ResourceDetailFeatureTaskEditorProps } from '@cibo/ui'
import { SelectRollupEditor } from '../../SelectRollupEditor'
import { EQIP_PRACTICES_CONSERVATION, EqipPracticesConservation } from './types'

export const RDEqipEligibilityConservationACEPResourceDetailFeature: ResourceDetailFeature<RDEqipEligibilityConservationACEP> =
  {
    traitId: 'eqipEligibilityConservationACEP',
    TaskEditor: (
      props: ResourceDetailFeatureTaskEditorProps<RDEqipEligibilityConservationACEP>
    ) => (
      <SelectRollupEditor<RDEqipEligibilityConservationACEP, readonly EqipPracticesConservation[]>
        options={EQIP_PRACTICES_CONSERVATION}
        detailKey="acepEnrolled"
        ns="@cibo/landmanager/RDEqipEligibilityConservationACEPResourceDetailFeature"
        {...props}
      />
    ),
  }
